module.exports = __webpack_public_path__ + "img/kakeibo-budget-planner_B09K281YMX.c96cbb86.jpg";